import { RefServiceType } from "../ref/Ref.dto";

export enum BundleGroup {
  Docs_Plan = "DOCS::PLAN",
  Safety_Plan = "SAFETY::PLAN",
  Safety_Purchase = "SAFETY::PURCHASE",
  Tmf_Plan = "TMF::PLAN",
  Converter_Plan = "CONVERTER::PLAN",
}

export enum BundleBillingType {
  Plan = "PLAN",
  Purchase = "PURCHASE",
  Trial = "TRIAL",
}

export enum BundlePriceCurrencyType {
  KRW = "KRW",
  USD = "USD",
}

export enum BundlePricePeriodType {
  Daily = "DAILY",
  Weekly = "WEEKLY",
  Monthly = "MONTHLY",
  Yearly = "YEARLY",
}

export enum SafetyBundleIdentifier {
  Test = "TEST",
  Ready = "READY",
  Enterprise = "ENTERPRISE",
  EnterprisePlus = "ENTERPRISE_PLUS",
  Trial = "TRIAL",
  E2b_R3_ExportPoint = "E2B_R3_EXPORT_POINT",
}

export enum BundleItemGrantType {
  User = "USER",
  Organization = "ORGANIZATION",
}

export enum BundleItemFunctionalityType {
  // Maven Docs
  Docs_EConsent_Limitless = "DOCS::ECONSENT:LIMITLESS",
  Docs_Archiver_Storage = "DOCS::ARCHIVER:STORAGE",
  Docs_Archiver_Viewer = "DOCS::ARCHIVER:VIEWER",
  Docs_Storage = "DOCS::STORAGE",
  Docs_Viewer = "DOCS::VIEWER",
  Docs_Viewer_Sharing = "DOCS::VIEWER:SHARING",
  Docs_Viewer_SharingExternal = "DOCS::VIEWER:SHARING_EXTERNAL",
  Docs_Viewer_SharingPeriod = "DOCS::VIEWER:SHARING_PERIOD",
  Docs_Viewer_IpWhitelist = "DOCS::VIEWER:IP_WHITELIST",
  Docs_Viewer_Watermark = "DOCS::VIEWER:WATERMARK",
  Docs_Viewer_Upload_Size_Limitless = "DOCS::VIEWER:UPLOAD_SIZE_LIMITLESS",
  Docs_Sign_ESign = "DOCS::SIGN:ESIGN",
  Docs_Sign_PesonalIdentification = "DOCS::SIGN:PERSONAL_IDENTIFICATION",
  Docs_Composer = "DOCS::COMPOSER",
  Docs_Composer_FolderVariable = "DOCS::COMPOSER:FOLDER_VARIABLE",
  Docs_Composer_Library = "DOCS::COMPOSER:LIBRARY",

  // Maven Safety,
  Safety_Dashboard = "SAFETY::DASHBOARD",
  Safety_Workspace = "SAFETY::WORKSPACE",
  Safety_Workspace_Info = "SAFETY::WORKSPACE_WORKSPACE_INFO",
  Safety_Workspace_Case_Import_E2b_R3 = "SAFETY::WORKSPACE:CASE:IMPORT_E2B_R3",
  Safety_Workspace_Case_Export_E2b_R3 = "SAFETY::WORKSPACE:CASE:EXPORT_E2B_R3",
  Safety_Workspace_Case_Request_Approve = "SAFETY::WORKSPACE:CASE:REQUEST_APPROVE",
  Safety_Workspace_Case_Request_Blind = "SAFETY::WORKSPACE:CASE:REQUEST_BLIND",
  Safety_Workspace_Case_Submission = "SAFETY::WORKSPACE:CASE_SUBMISSION",
  Safety_Workspace_Case_SubmissionDueDate = "SAFETY::WORKSPACE:CASE:SUBMISSION_DUE_DATE",
  Safety_Workspace_Case_EDC_Sync = "SAFETY::WORKSPACE:CASE:EDC_SYNC",
  Safety_Workspace_AuditTrail = "SAFETY::WORKSPACE:AUDIT_TRAIL",
  Safety_Workspace_Favorite = "SAFETY::WORKSPACE:FAVORITE",
  Safety_Workspace_Member_Manage = "SAFETY::WORKSPACE:MEMBER_MANAGE",

  // Maven Tmf
  Tmf_Dashboard = "TMF::DASHBOARD",
  Tmf_Study = "TMF::STUDY",

  // Maven Converter
  Converter_Study_Limitless = "CONVERTER::STUDY:LIMITLESS",
  Converter_Study_Storage = "CONVERTER::STUDY:STORAGE",
  Converter_Study_ImportFile_Limitless = "CONVERTER::STUDY:IMPORT_FILE:LIMITLESS",
  Converter_Study_DerivedFile_Limitless = "CONVERTER::STUDY:DERIVED_FILE:LIMITLESS",
  Converter_Library_ConversionFactor_Limitless = "CONVERTER::LIBRARY:CONVERSION_FACTOR:LIMITLESS",
  Converter_Study_CrfLabeling = "CONVERTER::STUDY:CRF_LABELING",
  Converter_Study_Validation = "CONVERTER::STUDY:VALIDATION",
  Converter_Study_ExternalDictionary_Validation = "CONVERTER::STUDY:EXTERNAL_DICTIONARY:VALIDATION",
}

export class BundleCriteria {
  static MAX_BUNDLE_NAME_LENGTH = 60;
  static MIN_BUNDLE_PRICE_VALID_FOR = 1;
  static MAX_BUNDLE_PRICE_VALID_FOR = 1000;
  static MAX_BUNDLE_PRICE_UNIT_PRICE = 9999999999;
  static MAX_BUNDLE_PRIORITY_VALUE = 1_000_000_000_000_000;
}

export class Bundle {
  id: bigint;
  service: RefServiceType;
  group: BundleGroup;
  billingType: BundleBillingType;
  identifier: string;
  isAlternative: boolean;
  isRenewable: boolean;
  prerequisiteBundleId?: bigint;
  name: {
    ko: string;
    en: string;
  };
  icon: string;
  description: {
    ko: string;
    en: string;
    startDate?: number;
    endDate?: number;
  };
  prices: BundlePrice[];
  items: BundleItem[];
  priority: number;
}

export type BundleEssential = Pick<Bundle, "id" | "service" | "group" | "billingType" | "identifier" | "name">;

export class BundlePrice {
  id: bigint;
  currency: BundlePriceCurrencyType;
  period?: BundlePricePeriodType;
  validFor?: number;
  validForInherited: boolean;
  unitPrice: number;
  unitAddPrice?: number;
  netPrice?: number;
  isStrategic: boolean;
}

export class BundleItem {
  id: bigint;
  grantTo: BundleItemGrantType;
  functionality: BundleItemFunctionalityType;
  quantity: number;
  isReloadable: boolean;
}
